import {
  default as CustomDevicePicker,
  devicePickerId,
} from "../../../../../UI/Specialized/DevicePicker";
import { useEffect, useMemo } from "react";
import { userPickerId } from "../../../../../UI/Specialized/UserPicker";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import useURLQuery from "../../../../../../Hooks/useURLQuery";
import { UIactions } from "../../../../../../store/slices/UI";
import { warehouseActions } from "../../../../../../store/slices/warehouse";
import {
  getRepoId,
  repoDataId,
} from "../../../../../../store/actions/repositories/getRepositories";
import { workerActions } from "../../../../../../store/slices/workers";
import { treesActions } from "../../../../../../store/slices/trees";
import { devicesDataId } from "../../../../../../store/actions/devices/getAllDevices";
import { getDevicesId } from "../../../../../../store/actions/devices/getDevices";

const DevicePicker = () => {
  const { dispatch, navigate, UI, warehouse } = useUIBp();
  const { id: user } = UI[userPickerId] ?? {};
  const { mid } = UI[devicePickerId] ?? {};
  const { user: urlUser, mid: urlMid } = useURLQuery();
  const devices = useMemo(() => {
    return warehouse[devicesDataId] ?? [];
  }, [warehouse]);

  const midClash = !!urlMid && !!mid && urlMid !== mid;
  const userSame = !!urlUser && !!user && urlUser === user;

  useEffect(() => {
    if (midClash && userSame) {
      const dvc = devices.find((x) => x.mid === urlMid);
      const value = { mid: dvc.mid, label: dvc.name };
      dispatch(UIactions.set({ id: devicePickerId, value }));
      dispatch(warehouseActions.unload(repoDataId));
      dispatch(workerActions.clear(getRepoId));
      navigate(`?user=${encodeURIComponent(urlUser)}&mid=${value.mid}`);
    }
  }, [
    dispatch,
    navigate,
    urlMid,
    urlUser,
    midClash,
    userSame,
    devices,
    warehouse,
  ]);

  const onLoaded = (devices) => {
    if (urlMid) {
      // if there is a URL machine set
      const option = devices.find((x) => x.mid === urlMid);
      const value = option ?? devices[0];
      dispatch(UIactions.setValue({ id: devicePickerId, value }));

      if (!option) {
        const url = `?user=${encodeURIComponent(
          urlUser
        )}&mid=${encodeURIComponent(value.mid)}`;
        navigate(url, { replace: true });
      }
    } else if (!urlMid) {
      // Set first entry if there is no URL machine
      const value = devices[0];
      dispatch(UIactions.setValue({ id: devicePickerId, value }));
      const url = `?user=${encodeURIComponent(
        urlUser
      )}&mid=${encodeURIComponent(value.mid)}`;
      navigate(url, { replace: true });
    }
  };

  const onChange = (value) => {
    dispatch(warehouseActions.unload(repoDataId));
    dispatch(treesActions.clearForest());
    dispatch(workerActions.clear(getRepoId));
    navigate(`?user=${encodeURIComponent(user)}&mid=${value.mid}`);
  };

  useEffect(() => {
    return () => {
      dispatch(warehouseActions.unload(devicesDataId));
      dispatch(UIactions.clear(devicePickerId));
      dispatch(workerActions.clear(getDevicesId));
    };
  }, [dispatch]);

  return (
    <CustomDevicePicker autoload {...{ onChange, onLoaded, user, size: 4 }} />
  );
};

export default DevicePicker;
